<template>
  <v-app-bar
    :class="{ collapsed }"
    class="header"
    app
    :height="['sm', 'xs'].includes($size) ? 60 : 100"
    color="white"
    fixed
  >
    <div class="header-start">
      <router-link to="/" exact>
        <span class="header-start__prepend">
          <img
            src="@/assets/logo__prepend.svg"
            alt="St. Jude Fitness Volunteer Leadership Conference"
          />
        </span>
        <div class="header-start__separator"></div>
        <span class="header-start__append">
          <img src="@/assets/logo__append.png" alt="The Power of One" />
        </span>
      </router-link>
    </div>
    <HeaderNav />
    <div class="header-end">
      <v-btn @click="$emit('input', !value)" icon class="sidebar-drawer">
        <v-icon color="jude_darkred" size="41">
          {{ value ? "$menuclose" : "$menu" }}
        </v-icon>
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
import HeaderNav from "./Header/HeaderNav";

export default {
  components: { HeaderNav },
  props: {
    collapsed: Boolean,
    value: Boolean,
  },
  computed: {
    rootUrl() {
      return `/${this.activePage?.slug || ""}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.header::v-deep {
  .v-toolbar__content {
    background: white;
    justify-content: space-between;
    padding: 0;
  }
}

.header {
  transition: 0.3s;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15) !important;

  &::v-deep .v-toolbar__content {
    transition: 0.3s;
  }
}

.header-start a {
  text-decoration: none;
}

.header-start {
  display: flex;
  align-items: center;
  padding: 20px;
  padding-left: 40px;

  a {
    display: flex;
  }

  &__separator {
    width: 2px;
    height: 67px;
    background: #b1b3b3;
    margin: 5px 20px;
  }

  &__append {
    img {
      width: 157px;
    }
  }
}

.header-label {
  font-family: "Pitch";
  font-weight: 600;
  font-size: 18px;
  letter-spacing: -0.04em;
  line-height: 17px;
  margin-left: 0.8em;
}

.header-end {
  display: none;
}

.sidebar-drawer {
  display: none;
}

@media screen and (max-width: 960px) {
  .sidebar-drawer {
    display: block !important;
  }

  .header-start {
    justify-content: space-between;
    &__prepend {
      height: 45px;
      > img {
        width: 103px;
        height: 45px;
      }
    }
    &__separator {
      width: 1px;
      height: 39px;
      margin: 5px 11px;
    }
    &__append {
      height: 44px;
      > img {
        width: 91px;
        height: 44px;
      }
    }
  }

  .header-start,
  .header-end {
    display: flex;
    align-items: center;
    padding: 10px;
  }

  .header-end {
    padding-right: 10px !important;
  }
}
</style>
